// 랜딩(홈) 페이지. 기존 App.jsx 에서 추출 — 라우트 객체(routes.jsx)와
// 프리렌더 도구가 공유한다. 모든 섹션은 정적 렌더 가능(브라우저 API 는
// useEffect 안에서만 사용)하므로 SSG 시 완성 HTML 로 구워진다.
import { Hero } from '../features/Hero/Hero';
import { LiveTicker } from '../features/LiveTicker/LiveTicker';
import { Partners } from '../features/Partners/Partners';
import { Coverage } from '../features/Coverage/Coverage';
import { Services } from '../features/Services/Services';
import { Strengths } from '../features/Strengths/Strengths';
import { ContractBanner } from '../features/ContractPath/ContractBanner';
import { EditorialBreak } from '../features/EditorialBreak/EditorialBreak';
import { ExpertCredibility } from '../features/ExpertCredibility/ExpertCredibility';
import { Inquiry } from '../features/Inquiry/Inquiry';
import { Seo } from '../components/Seo';
import { legalServiceGraph, breadcrumbJsonLd } from '../lib/structuredData';

export function LandingPage() {
  return (
    <>
      <Seo
        title="법무법인 오킴스 의료팀 — medilawyer"
        description="법무법인 오킴스 의료팀 공식 사이트. 의료기관·의료인을 위한 법률 자문과 의료분쟁 대응, 상담 서비스를 제공합니다. 의료 현장을 이해하는 전문 변호사진이 함께합니다."
        path="/"
        jsonLd={[legalServiceGraph(), breadcrumbJsonLd([{ name: '홈', path: '/' }])]}
      />
      <Hero />
      <LiveTicker />
      <Partners />
      <ExpertCredibility />
      <Coverage />
      <Services />
      <Strengths />
      <EditorialBreak />
      <ContractBanner />
      <Inquiry />
    </>
  );
}
